import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import getRegAvailable from 'app/selectors/getRegAvailable';

import selectIntroText from './selectIntroText';
import selectFIOEditAvailability from './selectFIOEditAvailability';


export default compose(
  withTranslation('app'),

  connect(
    (state, props) => ({
      showRemoveLink: getRegAvailable(state),
      introText: selectIntroText(state, props),
      disableFIOEdit: !selectFIOEditAvailability(state),
    })
  )
);
